export enum AccountModalUsageContext {
  None,
  LargePurchaseWorkflow,
  CharitableGivingWorkflow,
  DafAccounts,
  AnnuityPurchaseWhatIf = 4,
}

export interface AccountModalUsageContextOptions {
  CharitableGivingDonor?: number | null;
  CharitableGivingStrategy?: number | null;
  CharitableGivingKindOfProperty?: number | null;
}
